export const BGColor = '#012128'; //'#121212';
export const BGTextColor = 'white';

export const FGColor = '#012932'; //'#1a1625';
export const FGTextColor = 'white';

export const AccentColor = '#5BC9E1';
